import {RequestFactory} from "@/requests/RequestFactory";
const monitoramentoRequest = RequestFactory.get("monitoramento");


export default {
  namespaced: true,

  state: {
    items: {}
  },

  actions: {
    fetchMonitoramento: ({dispatch}, {monitoramentoId}) => {
      const payload = {resource: 'monitoramento', id: monitoramentoId}
      dispatch('fetchItemParent', payload, {root: true})
    },

    fetchMonitoramentos: ({dispatch}, indicadorId) => {
      const payload = {resource: 'monitoramento', id: indicadorId}
      dispatch('fetchItemsParent', payload, {root: true})
    },

    criarMonitoramento ({commit}, payload) {
      return monitoramentoRequest.post(payload.id, payload.progresso, payload.responsavelId, payload.data, payload.lancamentoId).then(response => {
        let payload = {resource: 'monitoramento', item: response.data}
        commit('setItem', payload, {root: true})

        payload = {resource: 'indicador', item: response.data.indicador}
        commit('setItem', payload, {root: true})

        return response.data
      })
    },

    editarIndicador ({commit}, payload) {
      return monitoramentoRequest.put(payload.monitoramentoId, payload.progresso).then(response => {
        const payload = {resource: 'monitoramento', item: response.data}
        commit('setItem', payload, {root: true})

        return response.data
      })
    },

    deletarMonitoramento ({commit}, payload) {
      const monitoramentoId = payload.id
      return monitoramentoRequest.delete(monitoramentoId).then(response => {
        let payload = {resource: 'monitoramento', itemId: monitoramentoId}
        commit('deleteItem', payload, {root: true})

        payload = {resource: 'indicador', item: response.data}
        commit('setItem', payload, {root: true})

        return response.data
      })
    },    
  },

  getters: {
    byIndicadorId: (state) => indicador => {
      if(state.items){
        return Object.values(state.items)
        .filter(monitoramento => monitoramento.indicador.id === indicador.id)
      }
      return {}
    },
  },
}







